import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';

export default async function saveActionApi(
  action,
) {
  try {
    const _ret = await axiosInstance({
      url: `${urlBaseAccreditation}/action/saveAction`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        id: action.id,
        type: action.type, // whatsapp
        serverNumber: action.serverNumber,
        description: action.description,
        templateId: action.templateId,
        numberOfTags: parseInt(action.numberOfTags),
        attributeTags: action.attributeTags,
        hasUrl: action.hasUrl,
        url: action.url,
        urlType: action.urlType, // "DOCUMENT", "VIDEO", "IMAGE"
        eventId: parseInt(action.eventId),
        scheduleId: parseInt(action.scheduleId),
        scheduleName: action.scheduleName,
        groupId: parseInt(action.groupId),
        groupName: action.groupName,
        organizerCellPhone: action.organizerCellPhone,
        apiType: 'inteegra',
        log: action.log,
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;

  } catch (error) {
    console.log('Error saveActionApi', error);
    throw error;
  }
}
